import {UNAUTHORIZED, FORBIDDEN, NOTFOUND, CSRF_ERROR, UNPROCESSABLE_ENTITY} from '../util'
import store from '../store'
import router from '../router'

// axiosの共通設定
window.axios = require('axios')
window.axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT + '/api/front/';
window.axios.defaults.withCredentials = true;

window.axios.interceptors.request.use((request)=>{
    store.dispatch('loader/incrementLoadingCount')
    request.headers['X-CSRF-TOKEN'] = store.getters['auth/token']
    return request;
})

window.axios.interceptors.response.use(function (response) {
    store.dispatch('loader/decrementLoadingCount')
    // 成功時の処理
    return response;
}, function (error) {
    store.dispatch('loader/decrementLoadingCount')

    // 失敗時の処理
    switch (error.response?.status) {
        case CSRF_ERROR:
            router.go({path: router.currentRoute.path, force: true})
            break
        case UNAUTHORIZED:
            store.commit('auth/setUser', null)
            router.push('/login')
            store.dispatch('modal/open', {
                isOpen: true,
                message: 'ログアウトしました。',
            })
            break
        case NOTFOUND:
        case FORBIDDEN:
            store.dispatch('modal/open', {
                isOpen: true,
                message: '不正なリクエストです。',
            })
            break
        case UNPROCESSABLE_ENTITY:
            break
        default:
            router.push('/login')
            store.dispatch('modal/open', {
                isOpen: true,
                message: '異常が発生しました。',
            })
    }
    return error.response
});